import React from "react";
import { MapPin } from "lucide-react";
import { SITE } from "../lib/site";

export default function ServiceAreas() {
  const loop = [...SITE.areas, ...SITE.areas];
  return (
    <section
      id="areas"
      data-testid="areas-section"
      className="relative py-24 lg:py-32"
    >
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <div className="grid lg:grid-cols-12 gap-10 items-end">
          <div className="lg:col-span-7">
            <span className="inline-block text-xs uppercase tracking-[0.2em] text-[#00B4D8] font-bold">
              Where we serve
            </span>
            <h2 className="mt-3 text-4xl sm:text-5xl font-extrabold text-[#0B2542] leading-tight">
              Baton Rouge, Livingston Parish & nearby.
            </h2>
          </div>
          <div className="lg:col-span-5 text-slate-600">
            <p className="text-base">
              Don't see your town? Give us a call — if you're nearby, we likely cover
              you. We travel throughout greater Baton Rouge and the surrounding parishes.
            </p>
          </div>
        </div>
      </div>

      <div className="mt-14 relative overflow-hidden">
        <div className="flex marquee-track w-max gap-4 px-6">
          {loop.map((area, i) => (
            <div
              key={i}
              data-testid={`area-pill-${i}`}
              className="inline-flex items-center gap-2 px-6 h-14 rounded-full bg-white border border-blue-100 text-[#0F4C81] font-semibold text-base whitespace-nowrap shadow-[0_8px_20px_rgba(15,76,129,0.10)]"
            >
              <MapPin className="h-4 w-4 text-[#00B4D8]" />
              {area}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
